import { Card, CardBody, Col } from "reactstrap";
import { Btn, Image } from "../../../../AbstractElements";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { AddFriend } from "../../../../Constant";
import { PEOPLE_KNOW_DATA } from "../../../../Data/SocialApp";
import { dynamicImage } from "../../../../Service/DynamicImage";
import { PeopleYouMayKnowProp } from "../../../../Type/SocialAppType";


const PeopleYouMayKnow = ({Heading}:PeopleYouMayKnowProp) => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={Heading} />
        <CardBody className="avatar-showcase">
          <div className="pepole-knows">
            <ul className="flex-wrap">
              {PEOPLE_KNOW_DATA.map((data, index) => (
                <li key={index}>
                  <div className="add-friend text-center">
                    <Image className="img-60 img-fluid rounded-circle" alt="user" src={dynamicImage(`${data.peopleImageName}`)}/>
                    <span className="d-block f-w-600">{data.peopleName}</span>
                    <Btn color="primary" size="xs">{AddFriend}</Btn>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default PeopleYouMayKnow;
